type LoggerProps = {
  message: string;
  error?: Error;
};

export function logger({ message, error }: LoggerProps): void {
  console.error(message, error);

  if (typeof window !== "undefined" && window.newrelic?.noticeError && error) {
    window.newrelic.noticeError(error);
  }
}
